import React from 'react';
export type ImageRatio = '21:9' | '16:10' | '4:3' | '1:1' | '3:4';
const ratioClasses: Record<ImageRatio, string> = {
  '21:9': 'aspect-[21/9]',
  '16:10': 'aspect-[16/10]',
  '4:3': 'aspect-[4/3]',
  '1:1': 'aspect-square',
  '3:4': 'aspect-[3/4]'
};
interface AppImageProps {
  src: string;
  /** Always descriptive. Never a filename, never the client name alone. */
  alt: string;
  ratio: ImageRatio;
  /** Applied to the frame. */
  className?: string;
  /** Applied to the image itself, for hover transforms and object positioning. */
  imageClassName?: string;
  /** Full-bleed hero layers only: drops the 1px border and 10px radius. */
  bleed?: boolean;
  /** Only for images on the dark band, where the bone hairline would glare. */
  borderClass?: string;
}

/**
 * The only way an image enters the page.
 *
 * Enforces the sitewide image system: one of five approved aspect ratios,
 * a 10px radius with a 1px #E6E6E2 border, lazy loading and required alt text.
 * See docs/IMAGE-SYSTEM.md for the art direction every source image must follow.
 */
export function AppImage({
  src,
  alt,
  ratio,
  className = '',
  imageClassName = '',
  bleed = false,
  borderClass = 'border-hairline'
}: AppImageProps) {
  const frame = bleed ? 'overflow-hidden' : `overflow-hidden rounded-card border bg-surface ${borderClass}`;
  return <div className={`${frame} ${ratioClasses[ratio]} ${className}`} data-id="element-99" data-mp="153iww1ouvnpq">
      <img src={src} alt={alt} loading="lazy" decoding="async" className={`h-full w-full object-cover ${imageClassName}`} data-id="element-100" data-mp="1stv3984gdce7" />
    </div>;
}